module.exports = __webpack_public_path__ + "img/keder_orange_ral2008.7a1be9fa.jpg";